//@flow
const StateType: PKStateTypes = {
  IDLE: 'idle',
  LOADING: 'loading',
  PLAYING: 'playing',
  PAUSED: 'paused',
  BUFFERING: 'buffering'
};

export {StateType};



// WEBPACK FOOTER //
// ./state/state-type.js


// WEBPACK FOOTER //
// core/state/state-type.js